/* unplugin-vue-components disabled */import { render } from "./LatestMusic.vue?vue&type=template&id=2257e163&ts=true"
import script from "./LatestMusic.vue?vue&type=script&lang=ts"
export * from "./LatestMusic.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/latestMusic/LatestMusic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2257e163"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2257e163', __exports__)) {
    console.log('reload')
    api.reload('2257e163', __exports__)
  }
  
  module.hot.accept("./LatestMusic.vue?vue&type=template&id=2257e163&ts=true", () => {
    console.log('re-render')
    api.rerender('2257e163', render)
  })

}


export default __exports__